export const buildKey = (prefix) => ({ key: prefix });

export const loadCache = (key) => {
  const cacheService = window.localStorage.getItem('cacheService');

  if (!cacheService || !key) {
    return undefined;
  }

  const cache = JSON.parse(cacheService);

  if (!cache) return undefined;
  return cache[key] || undefined;
};

export const setCache = (key, data) => {
  if (!key || !data) return;

  const cacheService = window.localStorage.getItem('cacheService');

  if (!cacheService) {
    window.localStorage.setItem(
      'cacheService',
      JSON.stringify({
        [key]: data,
      }),
    );
    return;
  }

  window.localStorage.setItem(
    'cacheService',
    JSON.stringify({
      ...JSON.parse(cacheService),
      [key]: data,
    }),
  );
};

export const clearCache = (key) => {
  const cacheService = window.localStorage.getItem('cacheService') || '{}';
  return window.localStorage.setItem(
    'cacheService',
    JSON.stringify({
      ...JSON.parse(cacheService),
      [key]: null,
    }),
  );
};

export default { loadCache, setCache, clearCache, buildKey };
